<template>
  <div class="group__info margin-top-10 padding-bottom-10">
    <div class="title font-size__medium">{{ title }}</div>
    <div class="content">
      <div class="form-input">
        <template>
          <el-table
            class="table detailRelatedDocs"
            style="width: 100%;"
            :data="relationDocs"
            size=""
            v-if="relationDocs && relationDocs.length"
          >
            <el-table-column label="Trích yếu" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="flex-row flex__left margin-right-10">
                  <file-type-image
                    :custom-class="''"
                    :file-extention="scope.row.fileExtention"
                    class="margin-right-10"
                  >
                  </file-type-image>
                  <span class="file-text-input style-fullWidth">
                    <el-input
                      class="style-fullWidth inputBg__white"
                      placeholder="-"
                      size="mini"
                      v-model="scope.row.quote"
                      :readonly="isDocRelation(scope.row)"
                    ></el-input>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Loại văn bản"
              width="120"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-select
                  class="style-fullWidth inputBg__white"
                  v-model="scope.row.relationType"
                  size="mini"
                  filterable
                  clearable
                  placeholder="-"
                >
                  <el-option
                    v-for="item in docRelationTypes"
                    :key="item.id"
                    :label="item.categoryName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="Số ký hiệu"
              width="120"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  size="mini"
                  v-model="scope.row.docCode"
                  placeholder="-"
                  class="style-fullWidth inputBg__white"
                  :readonly="isDocRelation(scope.row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="Ngày văn bản"
              width="125"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-date-picker
                  class="style-fullWidth inputBg__white "
                  v-model="scope.row.docDate"
                  type="date"
                  size="mini"
                  :prefix-icon="' '"
                  placeholder="dd/mm/yyyy"
                  format="dd/MM/yyyy"
                  :readonly="isDocRelation(scope.row)"
                ></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              v-if="checkedSignCA()"
              align="center"
              label="Yêu cầu ký số"
              width="125"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.docContentType == 'application/pdf'"
                  :style="{marginRight: 0}"
                  v-model="scope.row.checkedSignCA"
                />
                <el-popover
                  v-else
                  placement="top"
                  width="200"
                  trigger="hover"
                  content="Yêu cầu ký số với văn bản định dạng PDF">
                  <el-checkbox
                    slot="reference"
                    disabled
                  />
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column align="center" header-align="left" width="40">
              <template slot-scope="scope">
                <i
                  class="el-icon-circle-close font-size__large color__red clickable"
                  @click="removeRelationDoc(scope.row)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <div class="flex-row flex__left margin-top-10 margin-bottom-10">
            <el-upload
              v-if="checkedTaiFile()"
              :action="uploadAttachmentURL"
              :on-success="onUploadSuccess"
              :data="uploadRelationDocAdditionalData"
              :show-file-list="false"
              :headers="uploadAttachmentHeaders"
              :before-upload="file => beforeUpload(file)"
              :on-error="onUploadError"
              :on-change="() => (isUploadingRelationDocFlag = true)"
              v-loading="isUploadingRelationDocFlag && isUploading"
            >
              <el-button class="btnPlain margin-right-10">
                <i class="fas fa-cloud-upload-alt"></i>
                &nbsp;Tải file lên
              </el-button>
            </el-upload>
            <el-button class="btnPlain" @click="isOpenAddDocDialog = true">
              <i class="fas fa-mouse-pointer"></i>
              &nbsp;Chọn văn bản
            </el-button>
          </div>
        </template>
      </div>
    </div>
    <dialog-add-docs
      :isOpen="isOpenAddDocDialog"
      :docIds="docIds"
      v-if="isEnableAddDocDialog"
      @closed="isEnableAddDocDialog = false"
      @closeDialog="isOpenAddDocDialog = false"
      @submit="addDocRelations"
      :attachedType="attachedType"
    />
  </div>
</template>

<script>
  import FileTypeImage from "../job/FileTypeImage";
  import constants from "../../constants";
  import h from "../../services/h";
  import handleRequestErrorMixin from "../handleRequestErrorMixin";
  import uploadFileMixin from "../doc-in/uploadFileMixin";
  import categoryViewService from "../../services/categoryViewService";
  import DialogAddDocs from "../job/create-job/dialog-add-docs";
  import docRelationService from "../../services/docRelationService";

  export default {
    name: "doc-relations-form",
    mixins: [handleRequestErrorMixin, uploadFileMixin],
    components: {DialogAddDocs, FileTypeImage},
    props: ["attachedType", "title", "docId", "isCreateKyNgoai", "docCache"],

    computed: {
      Constants() {
        return constants
      },
      isVinataba() {
        return this.$store.getters.userDeptRole.tenantCode === constants.TENANT_CODE.VINATABA;
      },
    },
    data() {
      return {
        relationDocs: [],
        docRelationTypes: null,
        isUploadingRelationDocFlag: null,
        uploadRelationDocAdditionalData: {
          objectType: constants.ATTACHMENT_OBJECT_TYPE.RELATION_DOC
        },
        defaultRelationType: null,
        isOpenAddDocDialog: false,
        isEnableAddDocDialog: false,
        DOC_RELATION_ATTACHED_TYPE: constants.DOC_RELATION_ATTACHED_TYPE,
        docIds: []
      };
    },

    watch: {
      isOpenAddDocDialog(newValue) {
        newValue && (this.isEnableAddDocDialog = newValue);
      },
      docId() {
        this.loadRelationDocs();
      }
    },

    created() {
      this.loadCategories();
      this.loadRelationDocs();
      this.preloadNonAttachedDocRelations();
    },

    methods: {
      preloadNonAttachedDocRelations() {
        if(this.docCache === undefined) return;

        let preloadDoc = {
            docs: [],
            docType: 1
        }
        preloadDoc.docs.push(this.docCache)
        this.addPreloadedDocRelations(preloadDoc)
      },

      checkedTaiFile() {
        return this.attachedType !== constants.DOC_RELATION_ATTACHED_TYPE.VB_LIEN_QUAN_LINK ;
      },

      loadRelationDocs() {
        this.relationDocs = [];
        if (!this.docId) return;
        return docRelationService
          .findAll({objectId: this.docId, attachedType: this.attachedType})
          .then(response => {
            h.each(response.data, item => {
              this.relationDocs.push({
                id: item.id,
                objectRelateToId: item.objectRelateToId,
                docCode: item.docCode,
                quote: item.quote,
                docDate: item.docDate,
                objectTypeRelateTo: item.objectTypeRelateTo,
                relationType: item.relationType,
                attachedType: item.attachedType,
                docContentType: item.docContentType,
                checkedSignCA: item.checkedSignCA,
              });
            });
          });
      },

      getRelationDocs() {
        return this.relationDocs;
      },

      isDocRelation(docRelation) {
        return (
          docRelation.objectTypeRelateTo ===
          constants.DOC_RELATION_OBJECT_TYPE.VB_DEN ||
          docRelation.objectTypeRelateTo ===
          constants.DOC_RELATION_OBJECT_TYPE.OUTGOING_DOC
        );
      },

      removeRelationDoc(relationDoc) {
        this.relationDocs.splice(this.relationDocs.indexOf(relationDoc), 1);
        this.updateDocIds();
      },

      onUploadSuccess(vbAttachment) {
        this.isUploading = false;
        this.relationDocs.push({
          objectRelateToId: vbAttachment.id,
          quote: vbAttachment.fileName,
          docDate: vbAttachment.updateTime,
          objectTypeRelateTo: constants.DOC_RELATION_OBJECT_TYPE.ATTACHMENT,
          relationType: this.defaultRelationType,
          attachedType: this.attachedType,
          docContentType: vbAttachment.contentType,
          checkedSignCA: false
        });
      },

      loadCategories() {
        return categoryViewService
          .findAll(
            {groupCode: constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE},
            {sort: "order,asc"}
          )
          .then(response => {
            this.docRelationTypes = response.data;
            let canCuCategory = h.find(
              this.docRelationTypes,
              relationType =>
                relationType.categoryCode === "cancu" ||
                relationType.categoryName.toUpperCase() === "CĂN CỨ"
            );
            this.defaultRelationType = canCuCategory ? canCuCategory.id : null;
          });
      },

      addPreloadedDocRelations(event) {
        this.isOpenAddDocDialog = false;

        let newDocs = h.findAll(
          event.docs,
          doc =>
            (event.docType === constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN && doc.id !== null && doc.id !== '' )
        );
        let newRelationDocs = h.collect(newDocs, doc => {
          switch (event.docType) {
            case constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN:
              return {
                objectRelateToId: doc.id,
                docCode: doc.docCode,
                quote: doc.quote,
                docDate: doc.docDate,
                objectTypeRelateTo: constants.DOC_RELATION_OBJECT_TYPE.VB_DEN,
                attachedType: this.attachedType
              };
            case constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DI:
              return {
                objectRelateToId: doc.id,
                docCode: doc.docCode,
                quote: doc.quote,
                docDate: doc.docDate,
                objectTypeRelateTo:
                constants.DOC_RELATION_OBJECT_TYPE.OUTGOING_DOC,
                attachedType: this.attachedType
              };
          }
        });
        if (newRelationDocs) {
          this.relationDocs.push(...newRelationDocs);
          this.updateDocIds();
        }
      },

      addDocRelations(event) {
        this.isOpenAddDocDialog = false;
        let docType = event.docType;
        let docIds = this.docIds || [];

        let newDocs = h.findAll(
          event.docs,
          doc =>
            (docType === constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN &&
              docIds.indexOf(doc.vbIncomingDocUserViewKey.id) === -1) ||
            (docType === constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DI &&
              docIds.indexOf(doc.vbOutgoingDocUserViewKey.id) === -1)
        );

        let newRelationDocs = h.collect(newDocs, doc => {
          switch (docType) {
            case constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN:
              return {
                objectRelateToId: doc.vbIncomingDocUserViewKey.id,
                docCode: doc.docCode,
                quote: doc.quote,
                docDate: doc.docDate,
                objectTypeRelateTo: constants.DOC_RELATION_OBJECT_TYPE.VB_DEN,
                attachedType: this.attachedType
              };
            case constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DI:
              return {
                objectRelateToId: doc.vbOutgoingDocUserViewKey.id,
                docCode: doc.docCode,
                quote: doc.quote,
                docDate: doc.docDate,
                objectTypeRelateTo:
                constants.DOC_RELATION_OBJECT_TYPE.OUTGOING_DOC,
                attachedType: this.attachedType
              };
          }
        });

        if (newRelationDocs) {
          this.relationDocs.push(...newRelationDocs);
          this.updateDocIds();
        }
      },

      updateDocIds() {
        this.docIds = h.collect(
          h.findAll(
            this.relationDocs,
            item =>
              item.objectTypeRelateTo ===
              constants.DOC_RELATION_OBJECT_TYPE.VB_DEN
          ),
          item => item.objectRelateToId
        );
      },

      checkedSignCA() {
        if(this.isVinataba) {
          return !this.isCreateKyNgoai;
        }
        else {
          return this.attachedType === constants.DOC_RELATION_ATTACHED_TYPE.ATTACHED && !this.isCreateKyNgoai;
        }
      },
      beforeUpload(file) {
        const tenantCode = this.$store.getters.userDeptRole.tenantCode;
        switch (tenantCode){
          case constants.TENANT_CODE.VINATABA:
            return this.validateUploadFile(file)
          default:
            return this.validateUploadFile(file, { acceptFileTypes: constants.ACCPETED_CONTENT_TYPE_RELATION })
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/doc-relations-form.vue